import React from 'react';
import { ShoppingCart, Truck, CreditCard, CheckCircle, User, Mail, Phone, Home, Building, Map, MapPin, ChevronRight } from 'lucide-react';

const STEPS = [
  { icon: ShoppingCart, label: 'Cart', done: true },
  { icon: Truck, label: 'Shipping', active: true },
  { icon: CreditCard, label: 'Payment' },
  { icon: CheckCircle, label: 'Complete' },
];

export default function CheckoutPreview({ attributes = {} }) {
  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, system-ui, sans-serif' }}>
      {/* Progress steps */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0', marginBottom: '32px' }}>
        {STEPS.map((step, i) => (
          <React.Fragment key={step.label}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '6px' }}>
              <div style={{
                width: '40px', height: '40px', borderRadius: '50%', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                background: step.done ? '#059669' : step.active ? '#111827' : '#f3f4f6',
                color: step.done || step.active ? '#fff' : '#9ca3af',
                boxShadow: step.active ? '0 2px 8px rgba(0,0,0,0.15)' : 'none',
              }}>
                {step.done ? <CheckCircle size={18} /> : <step.icon size={18} />}
              </div>
              <span style={{
                fontSize: '11px', fontWeight: step.active ? 600 : 400,
                color: step.done ? '#059669' : step.active ? '#111827' : '#9ca3af',
              }}>{step.label}</span>
            </div>
            {i < STEPS.length - 1 && (
              <div style={{
                width: '60px', height: '2px', margin: '0 8px',
                background: step.done ? '#059669' : '#e5e7eb',
                marginBottom: '20px',
              }} />
            )}
          </React.Fragment>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '3fr 2fr', gap: '24px' }}>
        {/* Form */}
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 600, color: '#111827', marginBottom: '20px' }}>Shipping Address</h2>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
            <CheckoutField icon={User} placeholder="Full Name" required />
            <CheckoutField icon={Mail} placeholder="Email" required />
            <CheckoutField icon={Phone} placeholder="Phone" required />
            <CheckoutField icon={Home} placeholder="Street Address" required />
            <CheckoutField icon={Building} placeholder="Apt / Suite" />
            <CheckoutField icon={Building} placeholder="City" required />
            <CheckoutField icon={Map} placeholder="State" required />
            <CheckoutField icon={MapPin} placeholder="PIN Code" required />
          </div>
          <button style={{
            marginTop: '20px', width: '100%', padding: '14px', borderRadius: '10px',
            border: 'none', background: '#111827', color: '#fff', fontSize: '14px',
            fontWeight: 600, cursor: 'default', display: 'flex', alignItems: 'center',
            justifyContent: 'center', gap: '8px',
          }}>
            Continue to Payment <ChevronRight size={16} />
          </button>
        </div>

        {/* Order summary */}
        <div style={{
          padding: '20px', background: '#f9fafb', borderRadius: '12px',
          border: '1px solid #f0f0f0', height: 'fit-content',
        }}>
          <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#111827', marginBottom: '16px' }}>Order Summary</h3>
          {[
            { name: 'Classic Cotton Kurta', qty: 1, price: 2999 },
            { name: 'Silk Saree', qty: 1, price: 8999 },
          ].map((item, i) => (
            <div key={i} style={{
              display: 'flex', justifyContent: 'space-between', padding: '8px 0',
              borderBottom: '1px solid #f0f0f0', fontSize: '13px',
            }}>
              <div>
                <p style={{ color: '#374151', fontWeight: 500 }}>{item.name}</p>
                <p style={{ color: '#9ca3af', fontSize: '11px' }}>Qty: {item.qty}</p>
              </div>
              <span style={{ color: '#374151', fontWeight: 500 }}>{'\u20B9'}{item.price.toLocaleString()}</span>
            </div>
          ))}
          <div style={{ marginTop: '12px' }}>
            {[
              { label: 'Subtotal', value: '\u20B911,998' },
              { label: 'Shipping', value: 'Free', color: '#059669' },
            ].map(({ label, value, color }) => (
              <div key={label} style={{
                display: 'flex', justifyContent: 'space-between', padding: '4px 0', fontSize: '13px',
              }}>
                <span style={{ color: '#6b7280' }}>{label}</span>
                <span style={{ color: color || '#374151' }}>{value}</span>
              </div>
            ))}
            <div style={{
              display: 'flex', justifyContent: 'space-between', paddingTop: '12px',
              borderTop: '1px solid #e5e7eb', marginTop: '8px',
            }}>
              <span style={{ fontSize: '15px', fontWeight: 600, color: '#111827' }}>Total</span>
              <span style={{ fontSize: '18px', fontWeight: 700, color: '#111827' }}>{'\u20B9'}11,998</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function CheckoutField({ icon: Icon, placeholder, required }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: '10px',
      padding: '10px 12px', borderRadius: '8px', border: '1px solid #e5e7eb', background: '#fff',
    }}>
      <Icon size={16} style={{ color: '#9ca3af', flexShrink: 0 }} />
      <span style={{ fontSize: '13px', color: '#9ca3af' }}>{placeholder}</span>
      {required && <span style={{ color: '#ef4444', fontSize: '12px', marginLeft: 'auto' }}>*</span>}
    </div>
  );
}
